import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogoMark } from "../components/Logo";
import { Loader2, LogIn } from "lucide-react";

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = await login(email, password);
      const dest = (u.role === "admin" || u.role === "owner") ? "/admin" : (location.state?.from || "/first-season-artist-info");
      navigate(dest, { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Unable to sign in. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 15% 20%, rgba(179,92,255,0.35), transparent 32%), radial-gradient(circle at 85% 15%, rgba(140,255,0,0.16), transparent 28%), #050005" }} />
      <div className="relative z-10 w-full max-w-md">
        <Link to="/first-season-artist-info" className="flex justify-center mb-8"><LogoMark className="w-52" /></Link>
        <div className="hss-card p-8">
          <h1 className="font-ui font-extrabold uppercase text-white text-2xl">Welcome back</h1>
          <p className="text-white/50 text-sm mt-1 mb-6">Sign in to continue your First Season submission.</p>
          {error && <div className="mb-4 rounded-xl border border-red-400/40 bg-red-500/10 px-4 py-2.5 text-sm text-red-300">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="font-ui font-semibold text-white text-sm block mb-2">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="hss-input" placeholder="you@example.com" />
            </div>
            <div>
              <label className="font-ui font-semibold text-white text-sm block mb-2">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="hss-input" placeholder="Enter your password" />
            </div>
            <button type="submit" disabled={busy} className="btn-green w-full justify-center mt-2">
              {busy ? <Loader2 className="animate-spin" size={17} /> : <LogIn size={17} />} Sign In
            </button>
          </form>
          <p className="text-white/50 text-sm mt-6 text-center">
            New here? <Link to="/register" className="font-semibold" style={{ color: "#8cff00" }}>Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
